<header *ngIf="header$ | async as header">
  <div class="header-message">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-12 d-flex align-items-center">
          <div
            class="flex-grow-1 d-flex justify-content-center align-items-center"
            style="position: relative"
          >
            <span>{{ header.message }}</span>
          </div>
          <div
            class="dropdown ms-auto d-flex align-items-center"
            *ngIf="languages$ | async as languages"
          >
            <button
              class="btn btn-dropdown btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span class="text-uppercase">{{ savedLanguage?.code }}</span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <a
                class="dropdown-item text-uppercase"
                href="javascript:"
                *ngFor="let lang of languages"
                (click)="setLanguage(lang)"
                >{{ lang.code }}</a
              >
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <nav class="navbar navbar-expand-lg navbar-dark">
          <a class="navbar-brand" href="/">
            <img [src]="header.logo.url" alt="Logo" height="40" />
          </a>

          <button
            class="navbar-toggler"
            type="button"
            (click)="toggleNavbar()"
            [attr.aria-expanded]="!isNavbarCollapsed"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" [class.show]="!isNavbarCollapsed" id="mainNavbar">
            <ul class="navbar-nav ms-auto gap-3">
              <li
                *ngFor="let link of header.navbarItems"
                [ngClass]="{
                  dropdown: link.subMenu && link.subMenu.length > 0
                }"
              >
                <a
                  class="nav-link"
                  [routerLink]="link.url"
                  *ngIf="!link.subMenu || link.subMenu.length == 0"
                  [attr.target]="link.openInNewTab ? '_blank' : '_self'"
                  (click)="closeNavbar()"
                  >{{ link.text }}</a
                >
                <a
                  class="nav-link dropdown-toggle"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  *ngIf="link.subMenu && link.subMenu.length > 0"
                  [routerLink]="link.url"
                  (click)="closeNavbar()"
                >
                  {{ link.text }}
                </a>
                <div
                  class="dropdown-menu dropdown-menu-left"
                  aria-labelledby="navbarDropdown"
                  *ngIf="link.subMenu && link.subMenu.length > 0"
                >
                  <div class="dropdown-box">
                    <div
                      *ngFor="let subItem of link.subMenu"
                      class="half-size mb-1 mt-1"
                    >
                      <a
                        class="dropdown-item"
                        [routerLink]="subItem.url"
                        [attr.target]="
                          subItem.openInNewTab ? '_blank' : '_self'
                        "
                        (click)="closeNavbar()"
                      >
                        <strong>{{ subItem.text }}</strong>
                      </a>
                      <a
                        class="dropdown-item ms-2"
                        *ngFor="let subSubItem of subItem.subMenu"
                        [routerLink]="subSubItem.url"
                        [attr.target]="
                          subSubItem.openInNewTab ? '_blank' : '_self'
                        "
                        (click)="closeNavbar()"
                        >{{ subSubItem.text }}</a
                      >
                    </div>
                  </div>
                </div>
              </li>
              <li *ngIf="header?.ctaButton" class="nav-link ms-4 active">
                <a
                  [routerLink]="header.ctaButton.url"
                  [attr.target]="
                    header.ctaButton.openInNewTab ? '_blank' : '_self'
                  "
                  (click)="closeNavbar()"
                  >{{ header.ctaButton.text }}</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</header>
